// src/components/FAQ.js

import React from 'react';
import AccordionItem from './AccordionItem';
import { Link } from 'react-router-dom';
import './FAQ.css'; 
import { motion } from 'framer-motion'; // <-- Framer Motion Import

// =======================================
// FRAMER MOTION VARIANTS (Parent Container)
// =======================================
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      // Small delay before the first item starts
      delayChildren: 0.1,   
      // Time gap between each item
      staggerChildren: 0.08, 
    }
  }
};


const faqData = [
  // ... (Your faqData remains the same)
  {
    question: "How does Blue Print personalize my resources?",
    answer: "We use a proprietary algorithm that analyzes your current skills, target career path, available time, and preferred learning formats (video, article, interactive course) to filter resources. This ensures you only see content that is directly relevant to your next step.",
  },
  {
    question: "Is the platform free to use?",
    answer: "Yes, the core personalization flow and access to foundational resources is completely free. We offer premium curated resource lists and advanced tracking features through an optional subscription model.",
  },
  {
    question: "Can I track my progress?",
    answer: "Absolutely. Once you define your roadmap, you can save resources to your personalized path and mark them as complete. The dashboard visually tracks your progress toward your defined aspiration.",
  },
  {
    question: "Do I need to sign up to use the personalization flow?",
    answer: <span>You can explore the initial personalization flow without an account. However, to save your progress, create a roadmap, and access the full resource library, you will need to <Link to="/signup">sign up</Link>.</span>,
  },
];

const FAQ = () => {
  return (
    <section className="faq-section section-padding">
      <h2 className="section-heading">Questions? We Have Answers.</h2>
      
      <div className="faq-container main-content">
        {/* 1. Replace div with motion.div and apply whileInView */}
        <motion.div 
          className="accordion-list"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible" // Start animation when component is visible
          viewport={{ once: true, amount: 0.2 }} // Trigger when 20% of the list is visible
        >
          {faqData.map((item, index) => (
            // The AccordionItem must be updated to use motion.div and variants
            <AccordionItem
              key={index}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;